import { $api } from '@service/RequestService';
import { useQuery } from 'react-query';

import { crmConstants, crmModels } from '..';

export const useTagAll = (props: { enabled?: boolean } = {}) =>
  useQuery<crmModels.ITags>({
    queryKey: [crmConstants.queryKeys.TAG_ALL],
    queryFn: async () => {
      const res = await $api.get('/v1/tag/all');

      return res?.data?.data;
    },
    staleTime: Infinity,
    enabled: props?.enabled
  });
